import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  Table,
  Input,
  Button,
  InputGroup,
  InputGroupText
} from 'reactstrap';
import { AiOutlineSearch, AiOutlineEye, AiOutlineArrowRight } from 'react-icons/ai';
import api from '../../service/api';
import NavbarComponent from '../../components/Navbar/NavbarComponent';
import NavMenuComponent from '../../components/NavMenu/NavMenuComponent';
import ModalQuestionariosComponent from '../../components/ModalQuestionarios/ModalQuestionariosComponent';
import styles from './index.module.css';

export default function Vidas() {
  const [vidas, setVidas] = useState([]);
  const [filtradas, setFiltradas] = useState([]);
  const [statusVida, setStatusVida] = useState("ativo");
  const [busca, setBusca] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [vida, setVida] = useState("");
  const [vidaTelefone, setVidaTelefone] = useState("");

  useEffect(() => {
    api.get('vida')
      .then(({ data }) => {
        const sorted = data.sort((a, b) => a.vida_nome.localeCompare(b.vida_nome));
        setVidas(sorted);
        setFiltradas(sorted);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    let list = vidas;
    if (busca) {
      const lower = busca.toLowerCase();
      list = vidas.filter(v =>
        v.vida_nome && v.vida_nome.toLowerCase().includes(lower)
      );
    }
    setFiltradas(list);
  }, [busca, vidas]);

  const enviarQuestionario = (id, telefone) => {
    setVida(id);
    setVidaTelefone(telefone);
    setIsOpen(true);
  };

  return (
    <div className={styles.mainDiv}>
      <NavbarComponent />
      <NavMenuComponent />

      <ModalQuestionariosComponent
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        vida={vida}
        telefone={vidaTelefone}
      />

      <div className={styles.route}>
        <Link to="/" className={styles.link}> Home </Link> &gt;
        <span> Lista de Vidas </span>
      </div>

      <h2 className={styles.title}>Lista de Vidas</h2>

      <div className={styles.container}>
        <div className={styles.divInput}>
          <InputGroup>
            <Row>
              <Col xs="6">
                <InputGroup>
                  <Input
                    size="sm"
                    placeholder="Nome"
                    className={styles.inputBusca}
                    value={busca}
                    onChange={e => setBusca(e.target.value)}
                  />
                  <InputGroupText className={styles.textBuscar}>
                    <AiOutlineSearch size={17} className={styles.iconBuscar} />
                    Buscar
                  </InputGroupText>
                </InputGroup>
              </Col>
              <Col xs="6">
                <InputGroup>
                  <Input
                    type="select"
                    size="sm"
                    value={statusVida}
                    onChange={e => setStatusVida(e.target.value)}
                    className={styles.selectFiltro}
                  >
                    <option value="ativo">Ativo</option>
                    <option value="inativo">Inativo</option>
                  </Input>
                  <InputGroupText className={styles.textFiltro}>Filtro</InputGroupText>
                </InputGroup>
              </Col>
            </Row>
          </InputGroup>
          <div className={styles.contadorBolha} title="Total de vidas exibidas">
            {filtradas.filter(v => v.usuario_ativo === (statusVida === "ativo")).length}
          </div>
        </div>

        <Table size="sm" striped className={styles.table}>
          <thead>
            <tr>
              <th>Vida</th>
              <th>Data de Nascimento</th>
              <th>CPF</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filtradas
              .filter(v => v.usuario_ativo === (statusVida === "ativo"))
              .map(v => (
                <tr key={v.vida_id}>
                  <td className={styles.tbody}>{v.vida_nome}</td>
                  <td className={styles.tbody}>{v.data_nascimento}</td>
                  <td className={styles.tbody}>{v.cpf}</td>
                  <td>
                    <Link to={`/visualizarVida/${v.vida_id}`}>
                      <Button size="sm" className={styles.buttonPerfil}>
                        <AiOutlineEye size={17} className={styles.buttonIcon} />
                        Ver perfil
                      </Button>
                    </Link>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className={styles.buttonFormulario}
                      onClick={() => enviarQuestionario(v.vida_id, v.telefone)}
                    >
                      <AiOutlineArrowRight size={17} className={styles.buttonIcon} />
                      Enviar Questionário
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
